export const SMART_PLEX = 'smart-plex'
export const SMART_SWITCH = 'smart-switch'
export const HARDWIRED_COMPONENT = 'hardwired-component'
export const REFERENCE_PARAMETERS = 'reference_paramemeters'
export const HARDWIRED_SWITCH = 'hardwired-switch'
export const VEHICLE_SERIAL_NUMBER = 'vehicleSerial'
export const VEHICLES = 'vehicles'
export const SEQUENCE = 'sequence'
export const SERIAL = 'serial'
export const Model = 'Model'
export const Modal = 'Modal'
export const CUSTOMER = 'customer'
export const PRODUCTION_DESCRIPTION = 'product description'
export const DAYS_OUT = 'days out'
export const PRODUCTION_SCHEDULE = 'production schedule'
export const CLEVELAND = 'Cleveland'
export const FCCC = 'FCCC'
export const MT_HOLLY = 'Mt. Holly'
export const PORTLAND = 'Portland'
export const SANTIAGO = 'Santiago'
export const DASH_LAYOUT = '/dash-layout'
export const UPCOMING_BUILDS = 'upcoming builds'

export const plantLocationsCodes = {
  Portland: 'TMP',
  Cleveland: 'CLE',
  FCCC: 'SAL',
  'Mt. Holly': 'MTH',
  Santiago: 'SAN',
}

export const plantLocations = {
  TMP: 'Portland',
  CLE: 'Cleveland',
  SAL: 'FCCC',
  MTH: 'Mt. Holly',
  SAN: 'Santiago',
}

export const MQT12G = 'MQT12G'
export const MQT13G = 'MQT13G'
export const INDICATOR = 'indicator'
